import axiosClient from "utils/api";
const URI = "/profile";

export const getProfile = async () => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get profile :", error);
    throw error;
  }
};
export const getDrivePreferences = async () => {
  const URL = `${URI}/drivePreference`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get drive preferences :", error);
    throw error;
  }
};

export const manageDrivePreferences = async (payload) => {
  const URL = `${URI}/drivePreference`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data:payload
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get drive preferences :", error);
    throw error;
  }
};

export const updateProfile = async (payload) => {
  const URL = `${URI}/updateProfile`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "POST",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update profile:", error);
    throw error;
  }
};